// extracted by mini-css-extract-plugin
module.exports = {"event":"CustomEvents-moduleevent3iy","pulse":"CustomEvents-modulepulse1hF","loading":"CustomEvents-moduleloading1Ty","agendaEvent":"CustomEvents-moduleagendaEvent2Ep"};